export default {

    listPurchaseOrder(model) {
        return window.restApi.get('/v2/stock/purchase', {params: model});
    },
    getPurchaseOrder(id) {
        return window.restApi.get('/v2/stock/purchase/get?id=' + id);
    },
    savePurchaseOrder(model, config) {
        if (model.id) {
            return window.restApi.post('/v2/stock/purchase/update', model, config);
        } else {
            return window.restApi.post('/v2/stock/purchase/save', model, config);
        }
    },
    publishPurchaseOrder(model, config) {
        return window.restApi.post('/v2/stock/purchase/publish', model, config);
    },
    receivePurchaseOrder(model, config) {
        return window.restApi.post('/v2/stock/purchase/receive', model, config);
    },
    listStock(model) {
        return window.restApi.get('/v2/stock/warehouse', {params: model});
    },
    listUsage(model) {
        return window.restApi.get('/v2/stock/usage/list', {params: model});
    },
    getUsage(id) {
        return window.restApi.get('/v2/stock/usage/get?id=' + id);
    },
    saveUsage(model, config) {
        if (model.id) {
            return window.restApi.post('/v2/stock/usage/update', model, config);
        } else {
            return window.restApi.post('/v2/stock/usage/save', model, config);
        }
    },
    listSuhu(model) {
        return window.restApi.get('v2/master/suhu/list', {params: model});
    },
    getSuhu(id) {
        return window.restApi.get('v2/master/suhu/get?id=' + id);
    },
    saveSuhu(model, config) {
        if (model.id) {
            return window.restApi.post('v2/master/suhu/update', model, config);
        } else {
            return window.restApi.post('v2/master/suhu/save', model, config);
        }
    },
    listLokasi(model) {
        return window.restApi.get('v2/master/lokasi/list', {params: model});
    },
    getLokasi(id) {
        return window.restApi.get('v2/master/lokasi/get?id=' + id);
    },
    saveLokasi(model, config) {
        if (model.id) {
            return window.restApi.post('v2/master/lokasi/update', model, config);
        } else {
            return window.restApi.post('v2/master/lokasi/save', model, config);
        }
    },
    listKlasifikasi(model) {
        return window.restApi.get('v2/master/klasifikasi/list', {params: model});
    },
    getKlasifikasi(id) {
        return window.restApi.get('v2/master/klasifikasi/get?id=' + id);
    },
    saveKlasifikasi(model, config) {
        if (model.id) {
            return window.restApi.post('v2/master/klasifikasi/update', model, config);
        } else {
            return window.restApi.post('v2/master/klasifikasi/save', model, config);
        }
    }, 
    listVolume(model) {
        return window.restApi.get('v2/master/volume/list', {params: model});
    },
    getVolume(id) {
        return window.restApi.get('v2/master/volume/get?id=' + id);
    },
    saveVolume(model, config) {
        if (model.id) {
            return window.restApi.post('v2/master/volume/update', model, config);
        } else {
            return window.restApi.post('v2/master/volume/save', model, config);
        }
    },        
}
